module.exports = __webpack_public_path__ + "img/197.e621d926.png";